import React from 'react';
import { Container } from '@material-ui/core';
import SectionContent from '../../../components/common/SectionContent'

export default function LongTermApproach(props) {
    return (
        <>
           <Container>
                <SectionContent
                label="HSA.LongTermApproach.Label"
                detail="HSA.LongTermApproach.Detail"
                subTitle=""
                 />
            </Container>
        </>
    );
};